import { render, staticRenderFns } from "./orderInfoWindow.vue?vue&type=template&id=22b82e9b&scoped=true"
import script from "./orderInfoWindow.vue?vue&type=script&lang=js"
export * from "./orderInfoWindow.vue?vue&type=script&lang=js"
import style0 from "./orderInfoWindow.vue?vue&type=style&index=0&id=22b82e9b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b82e9b",
  null
  
)

export default component.exports